import Layout from 'layouts/Default'
import {
  Badge,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material'
import Breadcrumbs from 'components/Breadcrumbs'
import Label from 'components/Label'
import React, { ChangeEvent, useEffect, useState } from 'react'
import {
  DataGridCustom,
  StyledBoxContainerContent as ContainerContent,
  StyledBoxContainerTitle as ContainerTitle,
  StyledNumeroProcesso as NumeroProcesso,
} from './styles'
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown'
import { ModalPromotoria } from 'components/ModalPromotoria'
import {
  NotificationType,
  useNotifications,
} from 'pages/SearchNotifications/hook/notifications.hook'
import { GridColDef, GridRowParams } from '@mui/x-data-grid'
import dayjs from 'dayjs'
import { cnjMask } from 'utils/mask.util'
import DialogAlert from 'components/Dialog/Alert'
import { usePromotoriaContext } from 'contexts/promotoria.context'
import { useBackdrop } from 'contexts/backdrop.context'
import { useAuthContext } from 'contexts/auth.context'
import { Funcionalidades } from 'utils/helpers/funcionalidades'
import { useNavigate } from 'react-router-dom'

export const SearchNotificationsPage = () => {
  const navigate = useNavigate()
  const { handleHasPermission } = useAuthContext()
  const {
    promotorias,
    promotoriaSelecionada,
    onResearch,
    handleOpenModalPromotoria,
    openModalPromotoria,
    handleCloseModalPromotoria,
  } = usePromotoriaContext()
  const { handleBackdropOpen, handleBackdropClose } = useBackdrop()

  const {
    notifications,
    loaded,

    page,
    rowsOptions,
    rowsPerPage,
    totalOfElements,
    handleNewPage,
    handleRowsPerPage,

    handleVisualizarNotificacao,
    handleExcluirSelecionados,
    handleExcluirLidos,
  } = useNotifications(promotoriaSelecionada)

  const [openExcluirLidos, setOpenExcluirLidos] = useState(false)
  const [openExcluirSelecionados, setOpenExcluirSelecionados] = useState(false)

  const [selectedRows, setSelectedRows] = useState<number[]>([])
  const [selectAll, setSelectAll] = useState<boolean>(false)

  useEffect(() => {
    if (!loaded) {
      onResearch()
      handleBackdropOpen()
    } else {
      handleBackdropClose()
    }
  }, [loaded])

  const handleSelectAllChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSelectAll(event.target.checked)
    if (event.target.checked) {
      setSelectedRows(notifications.filter((item) => item.visualizado).map((row) => row.id))
    } else {
      setSelectedRows([])
    }
  }

  const handleCloseExcluirLidos = () => {
    setOpenExcluirLidos(false)
  }

  const handleCloseExcluirSelecionados = () => {
    setOpenExcluirSelecionados(false)
  }

  const handleModalExcluirLidos = async () => {
    await handleExcluirLidos().finally(() => {
      setOpenExcluirLidos(false)
      onResearch()
    })
  }

  const handleModalExcluirSelecionados = async () => {
    const selecionados = notifications.filter((item) => selectedRows.includes(item.id))
    if (selecionados) {
      await handleExcluirSelecionados(selecionados).finally(() => {
        setOpenExcluirSelecionados(false)
        onResearch()
      })
    }
  }

  const columns: GridColDef<any, any, any>[] = [
    {
      field: 'titulo',
      headerName: 'Título',
      flex: 1,
      minWidth: 350,
      maxWidth: 450,
      sortable: false,
      disableReorder: true,
      disableExport: true,
      disableColumnMenu: true,
      renderCell: (params) => <span className={'bold'}>{params.value}</span>,
    },
    {
      field: 'dataRegistro',
      headerName: 'Data de Registro',
      maxWidth: 400,
      minWidth: 200,
      sortable: false,
      disableReorder: true,
      disableExport: true,
      disableColumnMenu: true,
      renderCell: (params) => (
        <span>
          <span className={'bold'}>Data: </span>
          {dayjs(params.value).isValid()
            ? dayjs(params.value).format('DD/MM/YYYY HH:mm:ss')
            : params.value}
        </span>
      ),
    },
    {
      field: '',
      headerName: 'Número CNJ',
      flex: 1,
      minWidth: 380,
      sortable: false,
      disableReorder: true,
      disableExport: true,
      disableColumnMenu: true,
      renderCell: (params) => {
        const notificacao = params.row
          ? (JSON.parse(JSON.stringify(params.row)) as NotificationType)
          : null
        const numeroCnj = notificacao ? cnjMask(notificacao.processo.numeroCnj) : null
        return (
          <NumeroProcesso
            onClick={() =>
              handleHasPermission(Funcionalidades.notificacoes.visualizar) &&
              handleVisualizarNotificacao(notificacao)
            }
          >
            <span className={'bold'}>Número do Processo: </span>
            {numeroCnj}
          </NumeroProcesso>
        )
      },
    },
    {
      field: 'visualizado',
      headerName: 'Dot',
      sortable: false,
      disableReorder: true,
      disableExport: true,
      disableColumnMenu: true,
      renderCell: (params) => (
        <Box
          display={'flex'}
          flexDirection={'row'}
          justifyContent={'right'}
          alignContent={'start'}
          width={'100%'}
          height={'50%'}
        >
          {params.value !== true ? <Badge color='secondary' variant='dot' /> : null}
        </Box>
      ),
    },
  ]

  return (
    <Layout>
      <Grid container spacing={2}>
        <Grid container item xs={12} sx={{ mb: 2 }}>
          <Breadcrumbs>
            <Label text='Notificações' bold v={'body1'} />
          </Breadcrumbs>
        </Grid>
        <Grid item xs={12}>
          <ContainerTitle>
            <Label text='VISUALIZAR ALERTAS' v='h6' bold />
          </ContainerTitle>
          <ContainerContent>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <Label text='Total de Alertas' v='body1' sx={{ marginRight: '0.35rem' }} />
              <Label
                text={`(${totalOfElements})`}
                v='body1'
                color={'red'}
                sx={{ marginRight: '2rem' }}
              />
              {promotoriaSelecionada && (
                <Tooltip title={'Selecione o órgão.'}>
                  <Button
                    startIcon={<ExpandCircleDownIcon fontSize={'large'} />}
                    variant={'text'}
                    color={'secondary'}
                    disabled={promotorias.length <= 1}
                    onClick={() => handleOpenModalPromotoria()}
                  >
                    <b>{promotoriaSelecionada?.descricao}</b>
                  </Button>
                </Tooltip>
              )}
            </Box>
          </ContainerContent>
        </Grid>

        {loaded &&
          (notifications && notifications.length > 0 ? (
            <Grid item xs={12} display={'flex'} flexDirection={'column'} justifyItems={'end'}>
              <Box
                display={'flex'}
                margin={'0rem 1rem 0rem 1rem'}
                flexDirection={'row'}
                alignItems={'center'}
              >
                <Box flexGrow={1}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color='primary'
                        checked={selectAll}
                        disabled={!(notifications.filter((item) => item.visualizado).length > 0)}
                        onChange={handleSelectAllChange}
                        sx={{ '& .MuiSvgIcon-root': { fontSize: 24 } }}
                      />
                    }
                    label='Selecionar Todos'
                  />
                </Box>
                {handleHasPermission(Funcionalidades.notificacoes.excluir) && (
                  <Box display={'flex'}>
                    {selectedRows?.length > 0 ? (
                      <Typography
                        color={'primary'}
                        variant={'body2'}
                        onClick={() => setOpenExcluirSelecionados(true)}
                        sx={{ cursor: 'pointer' }}
                      >
                        <b>Excluir Alertas Selecionados</b>
                      </Typography>
                    ) : (
                      <Typography
                        color={'primary'}
                        variant={'body2'}
                        onClick={() => setOpenExcluirLidos(true)}
                        sx={{ cursor: 'pointer' }}
                      >
                        <b>Excluir Alertas Lidos</b>
                      </Typography>
                    )}
                  </Box>
                )}
              </Box>
              <DataGridCustom
                rows={notifications}
                columns={columns}
                autoHeight
                checkboxSelection
                localeText={{
                  footerRowSelected: (numero) =>
                    numero > 1 ? `${numero} selecionados` : `${numero} selecionado.`,
                }}
                slots={{
                  columnHeaders: () => null,
                }}
                onRowSelectionModelChange={(newSelection: any) => {
                  setSelectedRows(newSelection)
                  setSelectAll(newSelection.length === notifications.length)
                }}
                isRowSelectable={(params: GridRowParams) => params.row.visualizado}
                rowSelectionModel={selectedRows}
                pageSizeOptions={rowsOptions}
                rowCount={totalOfElements}
                paginationMode='server'
                componentsProps={{
                  pagination: {
                    labelRowsPerPage: 'Linhas por página:',
                    labelDisplayedRows: ({ from, to, count }) =>
                      `Linhas ${from}-${to} de um total de ${count} itens.`,
                    onRowsPerPageChange: handleRowsPerPage,
                  },
                }}
                getRowClassName={(params) => {
                  const row = JSON.parse(JSON.stringify(params.row)) as NotificationType
                  return row.visualizado
                    ? 'visualizado'
                    : params.indexRelativeToCurrentPage % 2 === 0
                    ? 'even'
                    : 'odd'
                }}
                onPaginationModelChange={({ page }) => {
                  handleNewPage(null, page)
                }}
                paginationModel={{
                  page: page,
                  pageSize: rowsPerPage,
                }}
              />
            </Grid>
          ) : (
            <Grid item xs={12} display={'flex'} flexDirection={'column'} justifyItems={'end'}>
              <Stack direction='row' justifyContent='center' spacing={2}>
                <Label text='Nenhum resultado encontrado...' bold />
              </Stack>
            </Grid>
          ))}
        <Grid
          item
          xs={12}
          sx={{ mb: 2 }}
          display={'flex'}
          flexDirection={'row'}
          justifyContent={'center'}
        >
          <Button variant={'outlined'} color={'secondary'} onClick={() => navigate('/')}>
            Ir para Tela Inicial
          </Button>
        </Grid>
      </Grid>
      <ModalPromotoria
        open={openModalPromotoria}
        onClose={handleCloseModalPromotoria}
        promotorias={promotorias}
      />
      <DialogAlert
        title='Excluir'
        contentText='Tem certeza que deseja excluir os alertas lidas?'
        open={openExcluirLidos}
        onSuccess={handleModalExcluirLidos}
        onClose={handleCloseExcluirLidos}
      />
      <DialogAlert
        title='Excluir'
        contentText='Tem certeza que deseja excluir os alertas selecionados?'
        open={openExcluirSelecionados}
        onSuccess={handleModalExcluirSelecionados}
        onClose={handleCloseExcluirSelecionados}
      />
    </Layout>
  )
}
